$ = jQuery; // in case of no-conflict jquery

atlas.site = new atlas.AtlasSite({ // config data
  cartDataBaseURL: 'https://atlasskateboarding.com',
  //slowCartAjax: true,
  //fakeCartAjax: true,
  cartAjaxEnabled: true,
  
  //hideMiniCart: true,
  
  productsListingRolloverImage: true,
  
  //brandsDataURL: 'https://tools.atlasskateboarding.com/api/data/brands_data.json',
  //searchDataURL: 'https://tools.atlasskateboarding.com/api/data/search_data.json',
  
  redoBlurb: 'Redo provides Free Returns and Package Protection from loss and damage.'
});

// on page loaded
$(function() {
  atlas.site.init();
});


// redo intercept

var firstScript = true;
var originalAppendChild = document.head.appendChild;
document.head.appendChild = function(child) {
  if (child instanceof HTMLScriptElement) {
    if (child.src && child.src.indexOf('redo-free-return-automation') != -1) {
      if (firstScript) {
        firstScript = false; // skip the first script because it does not behave
      } else {
        handleRedoScript(child.src);
        return;
      }
    }
  }
  originalAppendChild.call(document.head, child);
};
function handleRedoScript(src) {
  fetch(src).then(function(response) {
    response.text().then(function(text) {
      if (text.indexOf('attachShadow') != -1) {
        text = text.replace(/(attachShadow[^}]+['"])closed(['"][^}]*})/, '$1open$2'); // change closed shadow root to open
      }
      var script = document.createElement('script');
      script.textContent = text;
      document.body.appendChild(script);
    });
  });
}